import React from "react";
import PropTypes from "prop-types";
import { Breadcrumbs } from "@cars24/turbo-web/lib/breadcrumbs";
import { appUrl } from "../../../constants/url-constants";
import { computeBreadcrumbList } from "./selector";

const RtoVehInfoBreadcrumbs = ({
    state,
    rto,
    stateUrl,
    pageType
}) => {

    return (
        <div className="cvh">
            <Breadcrumbs baseUrl={appUrl()}
                list={computeBreadcrumbList({ pageType, state, stateUrl, rto })}
            />
        </div>
    );
};

RtoVehInfoBreadcrumbs.propTypes = {
    state: PropTypes.string,
    rto: PropTypes.string,
    stateUrl: PropTypes.string,
    pageType: PropTypes.string
};

export default RtoVehInfoBreadcrumbs;
